module.exports = __webpack_public_path__ + "media/vuesrc/themes/assante/images/auth/2fa-ee404c910b6f5bcc40d44952e4e138cc.png";